import { Divider, Typography ,Card} from "antd";
import BinInward from "../../../components/Wash/BinInward/BinInward";
import "../../../styles/global-ui.css";

const BinInwardPage = ({ userData }) => {
  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title-wrap">
          <Typography.Title level={3} className="page-title">
              Washing Center Bin Inward
          </Typography.Title>
          <Typography.Text className="page-subtitle">
            Scan or enter bin ID to receive bins into washing center
          </Typography.Text>
        </div>
      </div>

      <Divider className="page-divider" />
 <Card className="modern-card">
      <BinInward userData={userData} />
      </Card>
    </div>
  );
};

export default BinInwardPage;